const de = {
  brand: {
    name: 'Črna Kuhna',
    tagline: 'Aus dem Feuer. Aus Prlekija. Für die gemeinsame Tafel.',
    region: 'Vinski Vrh · Miklavž pri Ormožu',
  },
  photo: {
    badge: 'Authentische Fotografie',
  },
  nav: {
    home: 'Startseite',
    story: 'Geschichte',
    menu: 'Speisekarte',
    wines: 'Weine',
    gallery: 'Galerie',
    visit: 'Besuch',
    events: 'Veranstaltungen',
    gift: 'Geschenkgutscheine',
  },
  cta: {
    reserve: 'Tisch reservieren',
    menu: 'Speisekarte ansehen',
    call: 'Anrufen',
    email: 'Schreiben Sie uns',
    directions: 'Route öffnen',
    inquire: 'Anfrage senden',
    back: 'Zurück zur Startseite',
  },
  contact: {
    phone: '+386 71 825 143',
    phoneHref: '+38671825143',
    email: 'crnakuhna.mb@gmail.com',
    addressLine1: 'Vinski Vrh 6',
    addressLine2: '2275 Miklavž pri Ormožu, Slowenien',
    mapsQuery: 'Vinski Vrh 6, 2275 Miklavž pri Ormožu, Slowenien',
  },
  lang: {
    label: 'Sprache',
    sl: 'Slovenščina',
    en: 'English',
    de: 'Deutsch',
  },
  footer: {
    tagline: 'Aus dem Feuer. Aus Prlekija. Für die gemeinsame Tafel.',
    linksTitle: 'Links',
    contactTitle: 'Kontakt',
    visitTitle: 'Besuch',
    hoursNote: 'Geöffnet von Donnerstag bis Sonntag; Montag–Mittwoch geschlossen.',
    rights: 'Alle Rechte vorbehalten.',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundText: 'Diese Seite konnte nicht gefunden werden. Kehren Sie zur Startseite zurück und versuchen Sie es erneut.',
  },
};

export default de;